// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4548) return "static/chunks/4548-dd104e0d4e263cca.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "6b81adb7f12e31eb" + ".js";
};